import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserRole } from './types';
import { map, take } from 'rxjs/operators';

export const roleGuard = (requiredRole: UserRole): CanActivateFn => () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      if (user && user.role === requiredRole) {
        return true;
      }
      void router.navigate(['/calendar']);
      return false;
    })
  );
};
